import { cx } from '@emotion/css';
import ReactLoadingSkeleton from 'react-loading-skeleton';

import { offsetClassName } from './styles';
import { SkeletonProps } from './types';

const Skeleton = ({ lineHeight, offset, ...props }: SkeletonProps) => {
  return (
    <div
      style={{
        display: 'block',
        lineHeight: lineHeight ?? 1.6,
      }}
    >
      <ReactLoadingSkeleton
        className={cx({ [offsetClassName]: offset })}
        {...props}
      />
    </div>
  );
};

Skeleton.displayName = 'Skeleton';

export default Skeleton;
